import {css, StyleSheet} from "aphrodite";
import React from 'react';
import Config from "../config/Config";
import GridStyles from "../styles/styles";
import TextDiv from "./containers/TextDiv";

const Step = ({step, extraStyle}) => {
    const styles = StyleSheet.create({
        container: {
            ...GridStyles.define("max-content 17px max-content", "auto"),
            color: Config.colors.WHATS_NEW_TEXT,
            textAlign: "center",
            maxWidth: 260
        },
        circle: {
            ...GridStyles.setRowCol(1, 1),
            backgroundColor: Config.colors.STEPS_BACKGROUND,
            width: 50,
            height: 50,
            fontSize: 18,
            fontWeight: 600,
            lineHeight: "50px",
            borderRadius: "50%",
            margin: "0 auto"
        },
        text: {
            ...GridStyles.setRowCol(3, 1),
            fontSize: 18,
            lineHeight: 1.56,
            fontWeight: "bold"
        }
    });

    return (
        <div className={css(styles.container, extraStyle)}>
            <TextDiv extraStyle={styles.circle} text={step.step}/>
            <TextDiv extraStyle={styles.text} text={step.text}/>
        </div>
    );
};

export default Step;
